import { ValidationRuleset } from 'vuelidate';
import { User } from '@/store/models';
import { required, email } from 'vuelidate/lib/validators';

export type TUser = { user: User; validationGroup: string[] };

const existsEmail = () => {
  return true;
};

export const profileValidator: ValidationRuleset<TUser> = {
  user: {
    id: {
      required
    },
    email: {
      required,
      email,
      existsEmail
    },
    firstName: {
      required
    },
    lastName: {
      required
    },
    role: {
      required
    }
  }
};
